import { useMemo } from 'react';

import { useAccount } from '@hooks/useAccount';
import { useTeams } from '@hooks/useTeams';

import { checkStudyUserBelongsToTeam } from '../utils';

interface UseStudyTeamCountParams {
  study: Study;
}

interface UseStudyTeamCountResult {
  studyTeam: Team | undefined;
  teamUsersNotOnStudyTeamCount: number;
}

/**
 * Returns the study team and a count of non-admin study users who DONT belong to the study team.
 */
export function useStudyTeamCount({ study }: UseStudyTeamCountParams): UseStudyTeamCountResult {
  const {
    account: { team: accountUsers }
  } = useAccount();
  const { findTeam } = useTeams();
  const studyTeam: Team | undefined = study.team_id ? findTeam(study.team_id) : undefined;
  const teamUsersNotOnStudyTeamCount = useMemo(() => {
    if (!studyTeam) return 0;
    return study.user_ids.filter((user_id) => !checkStudyUserBelongsToTeam(user_id, studyTeam, accountUsers)).length;
  }, [studyTeam, study.user_ids, accountUsers]);

  return {
    studyTeam,
    teamUsersNotOnStudyTeamCount
  };
}
